// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f8c110ac","455":"82472635","977":"4d8efb85"}[chunkId] + ".chunk.js";
};